module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "title-chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781466815070_toc01#toctitle7",
      "id": "title7"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 6")])])])]), _vm._v(" "), _c('div', {
    staticClass: "subtitle-chapter"
  }, [_vm._v("SAME EVENING, 9:30 P.M.")]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("“"), _c('strong', {
    staticClass: "b"
  }, [_vm._v("D")]), _vm._v("id you say this was an Indian burial ground?” Rafferty was slouched against the bank wall next to Fenimore, waiting for his homicide squad to arrive. He had put the order through on his radio a few minutes earlier.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“That’s right,” Fenimore said.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The policeman had offered to call a squad car to take Fenimore to the hospital, but Fenimore had refused. After suffering this much, he was damned if he was going to miss all the fun.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“I feel their spirits watching me right now,” Rafferty said.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Whose?”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“The Indians’.” He stirred anxiously, glancing around. “I wish I had a pint.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“How did somebody who’s afraid of ghosts get to be a top cop in Philadelphia?”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Ghosts aren’t Philadelphia’s problem.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Shall I sing?” Fenimore was beginning to feel better.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Please don’t.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("That was all the encouragement he needed. He began to croon, “When Irish Eyes Are Smiling.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Can it. Why did you have to go and dig up a corpse two days before Halloween? Tomorrow’s Mischief Night. We have to work extra shifts, and the department’s overworked as it is.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“That’s why you had time to watch the Phillies?”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Can it.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“You’re getting repetitive.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Can—” Rafferty got to his feet and began pacing the perimeter of the small space, careful to avoid the hole and its occupant. The limited exercise seemed to give him no relief He disappeared down the alley to look for his reinforcements.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("As soon as he left, Fenimore’s head began to throb again. After what seemed a long time, he heard heavy footsteps in the alley, and Rafferty reappeared with his personal army in tow: two police officers, a detective, the medical examiner, and a photographer. From then on business was brisk. Fenimore, feeling uncharacteristically useless, remained against the bank wall.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Hey, Fenimore, look at this!”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Fenimore leaped to his feet and nearly fainted. The pain surged through his head, almost blinding him. A combination of curiosity and sheer willpower carried him the few steps to look into what had now become a large hole.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("There was nothing unusual about the woman’s appearance. Eyes closed, tawny skin, black hair. She was simply dressed in a T-shirt, jeans, and sandals. And there were no visible marks on her face, arms, hands, or feet. It was obvious she had been buried recently, within the past two or three hours. There was no evidence of decomposition or decay, and the medical examiner had assured them that rigor mortis was just beginning to set in. It was her posture that was unusual. Instead of lying flat, in the accepted burial position, her body was flexed, knees tucked under her chin, arms crossed over her chest.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Fenimore whistled. “And look how she’s facing.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Rafferty stared at him.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Fenimore returned his stare. “It’s traditional, among the Lenni-Lenape Indians, to bury their dead in a flexed position, turned toward the east.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49db9a81","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781466815070_c06.vue
// module id = 84
// module chunks = 0